import React, { useContext } from "react";

import { ProviderData } from "./types";

const initialState = {
  businessUnitConfig: {
    businessCode: "",
    businessUnitSlug: ""
  },
  businessUnitSlug: "",
  country: "",
  countryCode: "",
  footer: {},
  host: "",
  isMobile: false,
  language: "",
  locale: "",
  fullUrl: "",
  topbar: {},
  widgets: undefined
};

const AppContext = React.createContext<ProviderData>(initialState);
const { Provider } = AppContext;

const AppContextProvider: React.FC<ProviderData> = ({ children, ...props }) => (
  <Provider value={props}>{children}</Provider>
);

const useAppContext = () => useContext(AppContext);

export { AppContext, AppContextProvider, useAppContext };
